import React from "react";
import Typography from "@material-ui/core/Typography";

import { ISelectOption } from "types";
import { RadioGroup } from "components/RadioGroup";
import { RadioInput } from "components/RadioInput";

import { EditorGrid } from "../EditorGrid";

interface IRadioFieldProps {
  label: string;
  fieldName: string;
  options: ISelectOption[];
  disabled?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => void;
}

export const RadioField = ({
  label,
  fieldName,
  options,
  disabled,
  ...props
}: IRadioFieldProps) => {
  return (
    <>
      <EditorGrid centerAlign item xs={2}>
        <Typography variant="h3">{label}</Typography>
      </EditorGrid>
      <EditorGrid item xs={10}>
        <RadioGroup name={fieldName} row inFormik {...props}>
          {options.map((option) => (
            <RadioInput
              key={option.value}
              value={option.value}
              label={option.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </EditorGrid>
    </>
  );
};
